/**
 * Converts a decimal fraction (0-1) to a percentage (0-100), avoiding floating
 * point issues.
 * @param value number between 0 and 1
 * @returns percentage between 0 and 100
 */
export function decimalFractionToPercentage(
  value: number | undefined | null,
): number {
  return Number(((value ?? 0) * 100).toFixed(2));
}

/**
 * Converts a percentage (0-100) to a decimal fraction (0-1), avoiding floating
 * point issues.
 * @param value number between 0 and 100
 * @returns decimal fraction between 0 and 1
 */
export function percentageToDecimalFraction(
  value: number | undefined | null,
): number {
  return Number(((value ?? 0) / 100).toFixed(4));
}
